import { LEARNING_CENTER_HUB_CONFIG } from '@/constants/learningCenterHub';
import { useFilteredTasklistTasks } from '@/hooks/useFilteredTasklistTasks/useFilteredTasklistTasks';

export function useLearningCenterHub() {
  const { visibleLearningCenterTasks, isResolvingPages } = useFilteredTasklistTasks();

  return {
    hubConfig: LEARNING_CENTER_HUB_CONFIG,
    tasksForLearningCenter: visibleLearningCenterTasks,
    isLoading: isResolvingPages,
  };
}
